import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"padding":"16px 0","height":"calc(100% - 130px)"} }
const _hoisted_2 = {
  href: "https://github.com/GrailStack",
  style: {"color":"#ff6a00"}
}
const _hoisted_3 = { style: {"padding-top":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 预览 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 下一步 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 上一步 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 退出预览 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 下载 ")
const _hoisted_9 = { style: {"padding":"16px 0"} }

import {
  NLayout,
  NLayoutSider,
  NButton,
  darkTheme,
  NLayoutContent,
  NLayoutFooter,
  NIcon,
  NSpace,
  NLayoutHeader,
  NMenu,
  useMessage,
  NDivider,
  useDialog,
} from "naive-ui";
import Logo from "@/components/logo.vue";
import {
  WbSunnyOutlined,
  DarkModeOutlined,
  DehazeRound,
} from "@vicons/material";
import { LogoWechat, LogoGithub } from "@vicons/ionicons5";
import { computed, h } from "vue";
import { useMainStore } from "@/store/main";
import { postDownload } from "@/api/api";
import { saveAs } from "file-saver";
import JSzip from "jszip";
import pathsToDirectory from "@/utils/path";
import { useRouter } from "vue-router";
import hljs from "highlight.js";
import xml from "highlight.js/lib/languages/xml";
import java from "highlight.js/lib/languages/java";
import md from "highlight.js/lib/languages/markdown";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

hljs.registerLanguage("xml", xml);
hljs.registerLanguage("java", java);
hljs.registerLanguage("md", md);
const store = useMainStore();
const message = useMessage();
const dialog = useDialog();
const router = useRouter();
//操作
const handleNextStep = () => {
  store.step = "db";
};

const handleBack = () => {
  store.step = "basis";
};

const previewCode = () => {
  postDownload(store.form).then((res) => {
    if (
      res instanceof Blob &&
      res.type === "application/json" &&
      res instanceof Blob
    ) {
      const reader = new FileReader();
      reader.readAsText(res, "utf-8");
      reader.onload = function () {
        const obj = JSON.parse(reader.result as string);
        message.error(obj.msgContent);
      };
      return;
    }
    // @ts-ignore
    JSzip.loadAsync(res).then((zip) => {
      const files = zip.files;
      const directory = pathsToDirectory("", Object.keys(files));
      store.updateDirectory(directory);
      // @ts-ignore
      store.updateFiles(files);
      router.push("/code");
      store.step = "preview";
    });
  });
};

const handlePreview = () => {
  store.formRef.validate((errors: any) => {
    if (errors) return;
    if (store.tables.length === 0) {
      dialog.info({
        title: "提示",
        content: "是否跳过生成DAO？",
        positiveText: "是",
        negativeText: "否",
        onPositiveClick: () => {
          previewCode();
        },
        onNegativeClick: () => {
          console.log("不确定");
        },
      });
      return;
    }
    previewCode();
  });
};

const downloadFile = () => {
  postDownload(store.form).then((res) => {
    if (
      res instanceof Blob &&
      res.type === "application/json" &&
      res instanceof Blob
    ) {
      const reader = new FileReader();
      reader.readAsText(res, "utf-8");
      reader.onload = function () {
        const obj = JSON.parse(reader.result as string);
        message.error(obj.msgContent);
      };
      return;
    }
    // @ts-ignore
    saveAs(res, `${store.artifactId}.zip`);
  });
};

const handleGenerateFile = () => {
  if (store.step === "preview") {
    downloadFile();
    return;
  }
  store.formRef.validate((errors: any) => {
    if (errors) return;
    if (store.tables.length === 0) {
      dialog.info({
        title: "提示",
        content: "是否跳过生成DAO？",
        positiveText: "是",
        negativeText: "否",
        onPositiveClick: () => {
          downloadFile();
        },
        onNegativeClick: () => {
          console.log("不确定");
        },
      });
      return;
    }
    downloadFile();
  });
};

const handleEsc = () => {
  router.push("/");
  store.step = "db";
};

// dark
// @ts-ignore
const theme = computed(() => {
  if (store.theme === "dark") {
    return darkTheme;
  }
  return null;
});
const handleToggleTheme = () => {
  store.toggleTheme(store.theme === "light" ? "dark" : "light");
};

// menus
const createUrl = (name: string, href: string) => ({
  label: () => h("a", { href, target: "_blank" }, name),
  key: name,
});
const menusOptions = [
  {
    label: "Grail Stack",
    key: "Grail Stack",
    children: [
      createUrl("Overview", "https://itgrail.com/"),
      createUrl("Grail Boot", "https://itgrail.com/docs?id=7&version=1.0"),
      createUrl(
        "Grail toolkit",
        "https://itgrail.com/docs?id=10"
      ),
      createUrl("Grail CodeGen", "https://itgrail.com/docs?id=11"),
    ],
  },
  createUrl("官网", "https://itgrail.com"),
  createUrl("联系我们", "https://itgrail.com/about#contact"),
];

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NLayout), {
    class: "full-layout",
    "has-sider": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NLayoutSider), {
        width: "75",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(NSpace), { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(NButton), {
                  quaternary: "",
                  style: {"color":"#ff6a00"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NIcon), { size: "30" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DehazeRound))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", null, [
            _createVNode(_unref(NSpace), {
              align: "center",
              vertical: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NButton), { quaternary: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", _hoisted_2, [
                      _createVNode(_unref(NIcon), { size: "30" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(LogoGithub))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(NButton), {
                  quaternary: "",
                  style: {"color":"#ff6a00"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NIcon), { size: "30" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(LogoWechat))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(NLayout), {
        "has-sider": "",
        "sider-placement": "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NLayout), null, {
            default: _withCtx(() => [
              _createVNode(_unref(NLayoutHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), { justify: "space-between" }, {
                    default: _withCtx(() => [
                      _createVNode(Logo),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_unref(NMenu), {
                          mode: "horizontal",
                          options: menusOptions
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(NDivider), { style: {"margin-top":"0"} })
                ]),
                _: 1
              }),
              _createVNode(_unref(NLayoutContent), {
                style: {"height":"calc(100% - 186px)"},
                "content-style": "padding: 10px 35px 35px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              }),
              _createVNode(_unref(NLayoutFooter), { style: {"height":"90px"} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    justify: "center",
                    style: {"padding":"21px 0"}
                  }, {
                    default: _withCtx(() => [
                      (_unref(store).step === 'db')
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 0,
                            size: "large",
                            onClick: handlePreview
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(store).step === 'basis')
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 1,
                            size: "large",
                            onClick: handleNextStep
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(store).step === 'db')
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 2,
                            size: "large",
                            onClick: handleBack
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(store).step === 'preview')
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 3,
                            size: "large",
                            onClick: handleEsc
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(store).step === 'db' || _unref(store).step === 'preview')
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 4,
                            size: "large",
                            onClick: handleGenerateFile
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(NLayoutSider), {
            width: "75",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(NSpace), { justify: "center" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(NButton), {
                      quaternary: "",
                      circle: "",
                      onClick: handleToggleTheme
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NIcon), { size: "30" }, {
                          default: _withCtx(() => [
                            (!_unref(theme))
                              ? (_openBlock(), _createBlock(_unref(WbSunnyOutlined), { key: 0 }))
                              : (_openBlock(), _createBlock(_unref(DarkModeOutlined), { key: 1 }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})